<div class="appear my-20 mb-32 w-fit max-w-[calc(100%-48px)] md:max-w-[calc(100%-64px)] mx-auto px-[18px] md:px-20 py-12 rounded-xl shadow-xl linear-gradient-2">
  <p class="font-sans text-xl text-cream-100" [innerHTML]="safeContent"></p>
</div>
